//const ajaxurl = loc.ajax_url;

/**
 * Get all categories which is a parent
 */
const categories = document.querySelectorAll(
	'.header-widget-area .product-categories .cat-parent > a'
);

/**
 * Get widget heading
 */
const heading = document.querySelector(
	'.ast-mobile-popup-content .header-widget-area .widget-title'
);

/**
 * Create button with arrow
 */
const newButton =
	'<button type="button" class="arrow-btn"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg></button>';

if ( categories.length > 0 ) {
	/**
	 * Add button to category parents
	 */
	categories.forEach( function ( categorie ) {
		if ( categorie ) {
			categorie.insertAdjacentHTML( 'beforebegin', newButton );
		}
	} );

	/**
	 * Create click function for buttons
	 */
	const buttons = document.querySelectorAll( '.arrow-btn' );
	buttons.forEach( function ( btn ) {
		btn.addEventListener( 'click', catBtnInteraction );
	} );
}

/**
 * Add toggle class on click
 */
function catBtnInteraction() {
	const parent = this.closest( '.cat-item' );
	const child = parent.querySelector( '.children' );

	if ( ! child.classList.contains( 'toggle-children' ) ) {
		this.classList.add( 'toggle-btn' );
		child.classList.add( 'toggle-children' );
	} else {
		this.classList.remove( 'toggle-btn' );
		child.classList.remove( 'toggle-children' );
	}
}

/**
 * Add button to widget header on mobile only
 */
if ( heading ) {
	heading.insertAdjacentHTML( 'afterbegin', newButton );
}

/**
 * Create click function for headingButton
 */
const headingButton = document.querySelector( '.arrow-btn' );
if ( headingButton ) {
	headingButton.addEventListener( 'click', headBtnInteraction );
}

/**
 * Add toggle class on click
 */
function headBtnInteraction() {
	const parent = this.closest( '.widget_product_categories' );
	const child = parent.querySelector( '.product-categories' );

	if ( ! child.classList.contains( 'open-children' ) ) {
		this.classList.add( 'toggle-heading' );
		child.classList.add( 'open-children' );
		parent.classList.add( 'toggle-parent' );
	} else {
		this.classList.remove( 'toggle-heading' );
		child.classList.remove( 'open-children' );
		parent.classList.remove( 'toggle-parent' );
	}
}
